import { InitialState } from '../state';
import { AppReducer } from './app-reducer';

export const siteReducer: AppReducer<'Site'> = (state = InitialState.Site, action): typeof state => {
    switch (action.type) {
        case 'Site/Registration/Started':
            return {
                ...state,
                loading: true,
                success: false,
            };
        case 'Site/Registration/Succeeded':
            return {
                ...state,
                loading: false,
                success: true,
                siteId: action.payload.id,
                siteName: action.payload.name,
            };
        case 'Site/Registration/Failed':
            return {
                ...state,
                loading: false,
                success: false,
                error: true,
            };
        case 'Site/Registration/Reset':
            return {
                ...state,
                loading: false,
                success: false,
                error: false,
            };

        case 'Site/Delete/Started':
            return {
                ...state,
                deleteSiteLoading: true,
                deleteSiteSuccess: false,
            };
        case 'Site/Delete/Succeeded':
            return {
                ...state,
                deleteSiteLoading: false,
                deleteSiteSuccess: true,
            };
        case 'Site/Delete/Failed':
            return {
                ...state,
                deleteSiteLoading: false,
                deleteSiteSuccess: false,
            };
        case 'Site/Delete/Reset':
            return {
                ...state,
                deleteSiteLoading: false,
                deleteSiteSuccess: false,
            };

        case 'Site/Update/Started':
            return {
                ...state,
                loading: true,
                success: false,
            };
        case 'Site/Update/Succeeded':
            return {
                ...state,
                loading: false,
                success: true,
            };
        case 'Site/Update/Failed':
            return {
                ...state,
                loading: false,
                success: false,
            };
        case 'Site/Update/Reset':
            return {
                ...state,
                loading: false,
                success: false,
            };

        case 'Site/ExcludeStates/Succeeded':
            return {
                ...state,
                loading: false,
                success: false,
                excludedStates: action.payload.data,
                country: action.payload.country,
                state: action.payload.state,
            };




        default:
            return state;
    }
};
